"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonProductSchema = void 0;
const yup = __importStar(require("yup"));
const ba = __importStar(require("../attributes/buttonProductAttributes"));
const shared = __importStar(require("./sharedSchemas"));
const types_1 = require("../types");
const utils_1 = require("./utils");
const buttonProductUsesSchema = yup
    .array(yup.mixed().oneOf(Object.values(ba.Uses)))
    .min(1)
    .required();
exports.ButtonProductSchema = yup
    .object({
    productType: shared.productTypeSchema(types_1.ProductTypes.Buttons),
    sellingUnit: utils_1.reqSelectOneSchema(Object.values(ba.SellingUnit)),
    buttonType: shared.titleSetSmallSchema.required(),
    // material: shared.titleSetSmallSchema.required(),
    materials: yup
        .array(shared.titleSetSmallSchema)
        .default([])
        .max(2)
        .required(),
    colour: shared.colourSchema,
    buttonOpaqueness: utils_1.optSelectOneSchema(Object.values(ba.ButtonOpaqueness)),
    colourTone: shared.colourToneSchema,
    design: shared.sentenceSetSchema.optional(),
    widthMM: shared.widthMMSchema.required().max(200),
    uses: buttonProductUsesSchema,
    quantity: shared.quantitySchema.required(),
    packSize: shared.packSizeSchema.max(500),
    price: shared.priceSchema,
    // uniqueShape: yup
    //   .boolean()
    //   .default(false)
    //   .test('Test unique shape conditions', (value, context) => {
    //     const errorMsg = context.createError({
    //       message:
    //         'Unique shape buttons are only available individually or in packs of two.'
    //     });
    //     const packSize = parseInt(context.options.context?.product.packSize);
    //     if (
    //       value &&
    //       context.options.context?.product.sellingUnit ===
    //         ba.SellingUnit['Pack'] &&
    //       !isNaN(packSize) &&
    //       packSize !== 2
    //     )
    //       return errorMsg;
    //     else return true;
    //   })
    uniqueShape: yup.boolean().default(false),
    mixedWidth: yup.boolean().default(false)
})
    .when('$product.sellingUnit', (sellingUnit, schema) => {
    switch (sellingUnit) {
        case ba.SellingUnit.Individual:
            return schema.omit(['packSize']);
        default:
            return schema;
    }
})
    .test('Context Check', "Button Validator needs button product in it's context", (_, context) => {
    var _a;
    if (!((_a = context.options.context) === null || _a === void 0 ? void 0 : _a.product))
        return false;
    return true;
})
    .required();
//# sourceMappingURL=buttonProductSchema.js.map